import React from "react"
import ReactDOM from "react-dom"
import { PropTypes } from "prop-types"
import qs from "qs"
import unzip from "lodash.unzip"
import UniqId from "uniqid"
import commaNumber from "comma-number"
import "react-dates/initialize"
import moment from "moment"
import "moment-timezone"
import { getViewData } from "../../common/helpers/use_view_data"
import GetApi from "../../common/api/get"
import PostApi from "../../common/api/post"
import PeopleCounter from "../../common/components/people_counter/people_counter_component"
import PriceDetail from "../../common/components/price_detail/price_detail_component"
import Modal from "../../common/components/modal_dialog/modal_wrapper_component"
import "./Calendar.scss"
import isValidDate from "../../common/helpers/is_valid_date"
import { Trans, withNamespaces } from "react-i18next"
import { compose } from "redux"
import CurrencyHelper from "../../common/helpers/currency_helper"
const { ANCHOR_RIGHT } = ReactDatesConstants
const { SingleDatePicker } = ReactDates

export class Calendar extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      checkin: "",
      checkout: "",
      guests: [],
      rooms: 0,
      error: "",
      minimum_price: this.props.minimum_price,
      base_price: this.props.base_price,
      max_rooms: 0,
      calendars: {},
      prices: {
        total_price: 0,
        service_fee: 0,
        consumption_tax: 0,
        cleaning_fee: 0,
        accommodation_fee: 0,
        additional_person_fee: 0,
        hotel_tax: 0,
        normal_accommodation_fee: 0,
        dates: []
      },
      focused_checkin: false,
      focused_checkout: false,
      checkout_visible_month: null,
      showBookingDetail: false,
      showBookingBoxTrigger: false,
      calculating: false,
      calendar_loading: false,
      viewData: getViewData()
    }

    // Initialize the style of react-dates
    ThemedStyleSheet.registerInterface(aphroditeInterface)
    ThemedStyleSheet.registerTheme(VsTheme)

    // initialize today with timezone
    this.today = moment().tz(this.props.timezone)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    const queryParams = qs.parse(this.props.search, {
      ignoreQueryPrefix: true
    })
    const {
      checkin,
      checkout,
      rooms = 1,
      adults = "1",
      children = "0",
      infants = "0"
    } = queryParams

    let guests
    let roomNum
    if (!Array.isArray(rooms)) {
      // roomsの初期値は1とする
      guests = this.guestsGroupBy(
        { adult: adults, child: children, infant: infants },
        rooms
      )
      roomNum = rooms
    } else {
      // trivago等のmetasearch対応（roomsが配列）
      guests = this.guestsGroupByForTrivago(rooms)
      roomNum = guests.length
    }

    this.setState({
      checkin: isValidDate(checkin) ? moment(checkin) : null,
      checkout: isValidDate(checkout) ? moment(checkout) : null,
      rooms: roomNum,
      guests: guests
    })
  }

  componentDidMount() {
    // Get 2 months calendar data at first.
    const promise = [...Array(2)].map((_, i) => {
      const d =
        this.state.checkin === null ? moment(this.today) : this.state.checkin
      return this.getCalendars(moment(d).add(i, "months"))
    })

    Promise.all(promise).then(() => {
      this.updateMaxRooms()
      this.getPriceDetail()
    })
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.minimum_price !== this.props.minimum_price) {
      this.updateMinimumPrice(nextProps.minimum_price)
    }
  }

  /**
   * それぞれRoomごとに均等に分ける
   * { adults: 3, children: 2, infants: 1 }, room: 2
   * ↓
   * [{adult: 2, child: 1, infant: 1}, {adult: 1, child: 1, infant: 0}]
   */
  guestsGroupBy(guestsParam, roomNum) {
    function group(array, targetArray, key) {
      array.forEach((room) => {
        if (!(key in room)) {
          room[key] = 0
        }

        if (targetArray.length !== 0) {
          targetArray.pop()
          room[key] += 1
        }
      })

      if (targetArray.length !== 0) {
        group(array, targetArray, key)
      }
    }

    const roomArray = [...Array(Number(roomNum))].map((arr) =>
      Object.create(null)
    )
    for (let key in guestsParam) {
      const array = new Array(Number(guestsParam[key])).fill(0)
      group(roomArray, array, key)
    }

    return roomArray
  }

  /**
   * guestsGroupByForTrivago
   *
   * trivago等のmetasearch対応
   * rooms: [{adults: [ "1","1"], children: [ "0","0"], infants: [ "0","0"]}]
   * → [{adult: 1, child: 0, infant: 0}, {adult: 1, child: 0, infant: 0}] に整形する
   */
  guestsGroupByForTrivago(rooms) {
    const unziped = unzip(
      Object.keys(rooms[0]).map((key) => {
        if (!Array.isArray(rooms[0][key])) {
          // room が１つの場合 {adult: "1", child: "1", infant: "1"} こう来るので、配列にする
          return [].concat(Number(rooms[0][key]))
        }
        return rooms[0][key].map((val) => Number(val))
      })
    )

    const roomArray = unziped.map((room) => {
      return ["adult", "child", "infant"].reduce((assignment, val, i) => {
        assignment[val] = room[i]
        return assignment
      }, {})
    })
    return roomArray
  }

  getCalendars(date) {
    if (date.isBefore(this.today, "month")) return

    const listingParams = {
      start_date: date.startOf("month").format("YYYY-MM-DD"),
      end_date: date.endOf("month").format("YYYY-MM-DD"),
      currency_code: CurrencyHelper.metaCurrencyCode()
    }

    const previewParams = {
      start_date: date.startOf("month").format("YYYY-MM-DD"),
      end_date: date.endOf("month").format("YYYY-MM-DD"),
      year: moment(date).toDate().getFullYear(),
      month: moment(date).toDate().getMonth() + 1,
      currency_code: CurrencyHelper.metaCurrencyCode()
    }

    this.setState({ calendar_loading: true })

    // プレビューカレンダー/通常のカレンダーを判定
    const calendarEndpoint = this.props.is_preview
      ? routeUrlHelper.roomGroupCalendarsPath(this.props.room_group_id)
      : routeUrlHelper.listingCalendarsPath(this.props.room_group_id)

    const calendarParams = this.props.is_preview
      ? previewParams
      : listingParams

    const getApi = new GetApi()
    return getApi
      .execute(calendarEndpoint, calendarParams)
      .then((res) => {
        this.setCalendars(res.body, date.format("YYYY-MM"))
      })
      .catch((res) => {
        this.setState({ error: res.body })
      })
      .finally(() => {
        this.setState({ calendar_loading: false })
      })
  }

  setCalendars(values, resetMonth) {
    const calendars = this.state.calendars

    if (resetMonth) {
      calendars[resetMonth] = {}
    }

    values.forEach((e) => {
      const d = moment.tz(e.date, this.props.timezone)
      if (d.isSameOrAfter(moment(this.today).format("YYYY-MM-DD"), "day")) {
        calendars[d.format("YYYY-MM")] = calendars[d.format("YYYY-MM")] || {}
        calendars[d.format("YYYY-MM")][e.date] = e
      }
    })
    this.setState({ calendars })
  }

  changePickerMonth(isPrev, next) {
    if (next.isSameOrAfter(this.today, "month")) {
      this.getCalendars(moment(next).add(isPrev ? 0 : 1, "months"))
    }
  }

  changeCheckoutPickerMonth(isPrev, next) {
    this.setState({
      checkout_visible_month: moment(next).startOf("month")
    })

    this.changePickerMonth(isPrev, next)
  }

  isDayBlocked(key, date, at = new Date()) {
    const granularity = "day"

    if (key == "checkin") {
      if (date.isBefore(this.today.format("YYYY-MM-DD"), granularity)) {
        return true
      }

      // accept_days
      if (
        this.props.accept_days &&
        date.isBefore(
          moment(this.today).add(this.props.accept_days, "days"),
          granularity
        )
      ) {
        return true
      }

      // accept_days_hour
      if (
        this.props.accept_days_hour &&
        date.isSame(
          moment(this.today).add(this.props.accept_days, "days"),
          granularity
        ) &&
        this.props.accept_days_hour <= moment(at).hour()
      ) {
        return true
      }

      if (
        !this.isAvailableBetween(
          date,
          moment(date).add(this.allowedMinimumStaysForCheckin(date), "day")
        )
      ) {
        // calendars between checkin and a valid checkout are all available
        return true
      }
    }

    if (key === "checkout") {
      if (date.isSameOrBefore(this.today, granularity)) {
        return true
      }

      if (this.state.checkin) {
        // before check-in day
        if (date.isSameOrBefore(moment(this.state.checkin), granularity)) {
          return true
        }
        if (!this.isStayNightsAllowed(this.state.checkin, date)) {
          return true
        }

        // calendars between checkin and the given date are all available
        if (!this.isAvailableBetween(this.state.checkin, date)) {
          return true
        }
      } else {
        const maximumCheckin = moment(date).subtract(
          this.legacyMinimumStayNights(),
          "day"
        )
        // accept_days
        if (
          this.props.accept_days &&
          maximumCheckin.isBefore(
            moment(this.today).add(this.props.accept_days, "days"),
            granularity
          )
        ) {
          return true
        }

        // accept_days_hour
        if (
          this.props.accept_days_hour &&
          maximumCheckin.isSame(
            moment(this.today).add(this.props.accept_days, "days"),
            granularity
          ) &&
          this.props.accept_days_hour <= moment(at).hour()
        ) {
          return true
        }

        // calendars between checkin and the given date are all available
        if (!this.isAvailableBetween(maximumCheckin, date)) {
          return true
        }
      }
    }

    // default (opened)
    return false
  }

  calendarForDate(date) {
    const {
      [moment(date).format("YYYY-MM")]: {
        [date.format("YYYY-MM-DD")]: calendar
      } = {}
    } = this.state.calendars
    return calendar
  }

  legacyMinimumStayNights() {
    return this.props.minimum_stays || 1
  }

  allowedStayNightsForCheckin(checkin) {
    const calendar = this.calendarForDate(checkin)

    if (
      !calendar ||
      !Object.prototype.hasOwnProperty.call(calendar, "allowed_stay_nights") ||
      calendar.allowed_stay_nights == null
    ) {
      return null
    }

    if (!Array.isArray(calendar.allowed_stay_nights)) {
      return []
    }

    return calendar.allowed_stay_nights
      .map((stayNights) => Number(stayNights))
      .filter((stayNights) => !isNaN(stayNights) && stayNights > 0)
  }

  allowedMinimumStaysForCheckin(checkin) {
    const allowedStayNights = this.allowedStayNightsForCheckin(checkin)

    if (allowedStayNights && allowedStayNights.length > 0) {
      return allowedStayNights[0]
    }

    return this.legacyMinimumStayNights()
  }

  stayNightsBetween(checkin, checkout) {
    const normalizeStayDate = (date) =>
      moment(date).clone().startOf("day").hour(12)

    return normalizeStayDate(checkout).diff(
      normalizeStayDate(checkin),
      "days"
    )
  }

  isStayNightsAllowed(checkin, checkout) {
    const stayNights = this.stayNightsBetween(checkin, checkout)
    const allowedStayNights = this.allowedStayNightsForCheckin(checkin)

    if (allowedStayNights !== null) {
      return allowedStayNights.indexOf(stayNights) >= 0
    }

    if (this.props.minimum_stays && stayNights < this.props.minimum_stays) {
      return false
    }

    if (this.props.maximum_stays && stayNights > this.props.maximum_stays) {
      return false
    }

    return true
  }

  isCalendarAvailable(date) {
    const calendar = this.calendarForDate(date)

    return !!(
      calendar &&
      calendar.is_open &&
      calendar.price > 0 &&
      calendar.inventories >= this.state.rooms
    )
  }

  /**
   * チェックインからチェックアウトの日付までの期間、利用可能かどうかチェックする。
   *
   * @param  {string} checkin
   * @param  {string} checkout
   */
  isAvailableBetween(checkin, checkout) {
    for (
      let date = moment(checkin);
      date.isBefore(checkout, 'day');
      date.add(1, "day")
    ) {
      if (!this.isCalendarAvailable(date)) {
        return false
      }
    }
    // 準備期間確認
    for (
      let date = moment(checkout),
        intervals = moment(checkout).add(this.props.interval_days, "days");
      date.isBefore(intervals);
      date.add(1, "day")
    ) {
      const calendar = this.calendarForDate(date)
      // 準備期間の場合はカレンダーが無いまたはカレンダーの在庫数が部屋数以上ならOK
      if (
        calendar &&
        calendar.price !== null &&
        calendar.inventories < this.state.rooms
      ) {
        return false
      }
    }
    return true
  }

  refocusCheckoutPicker(nextState = {}) {
    this.setState(
      Object.assign({}, nextState, { focused_checkout: false }),
      () => {
        this.setState({ focused_checkout: true })
      }
    )
  }

  onDateChange(key, date) {
    const nextState = { [key]: date }
    if (key === "checkout") {
      nextState.checkout_visible_month = this.defaultCheckoutVisibleMonth(
        this.state.checkin,
        date
      )
    }

    this.setState(nextState, () => {
      this.updateMaxRooms()
      this.updateGuestsArray()
      if (key === "checkin") {
        const state = {}
        let shouldRefocusCheckout = false
        let nextCheckout = this.state.checkout

        if (this.state.checkout == null) {
          shouldRefocusCheckout = true
        } else if (this.state.checkin) {
          // 選択されたチェックイン日とチェックアウト日から計算して、
          // 宿泊可能でなければチェックアウト日をクリアする
          if (
            this.state.checkin.isSameOrAfter(this.state.checkout, "day")
          ) {
            state.checkout = null
            nextCheckout = null
            shouldRefocusCheckout = true
          } else if (
            !this.isStayNightsAllowed(this.state.checkin, this.state.checkout)
          ) {
            state.checkout = null
            nextCheckout = null
            shouldRefocusCheckout = true
          } else if (
            !this.isAvailableBetween(this.state.checkin, this.state.checkout)
          ) {
            state.checkout = null
            nextCheckout = null
            shouldRefocusCheckout = true
          }
        }

        state.checkout_visible_month = this.defaultCheckoutVisibleMonth(
          this.state.checkin,
          nextCheckout
        )

        if (shouldRefocusCheckout) {
          this.refocusCheckoutPicker(state)
        } else if (Object.keys(state).length) {
          this.setState(state)
        }
      }
    })
  }

  onDatePickerFocusChange(key, focused) {
    this.setState({ [`focused_${key}`]: focused.focused })
  }

  updateRoomCount(e) {
    const value =
      e.target.value > this.state.max_rooms
        ? this.state.max_rooms
        : e.target.value
    this.setState({ rooms: value }, () => {
      this.updateGuestsArray()
    })
  }

  updateGuestsArray() {
    const guests = this.state.guests
    const current = guests.length
    if (current < this.state.rooms) {
      [...Array(this.state.rooms - current)].map(() => {
        guests.push({ adult: 1, child: 0, infant: 0 })
      })
    } else if (current > this.state.rooms) {
      [...Array(current - this.state.rooms)].map(() => {
        guests.pop()
      })
    }
    this.setState({ guests: guests }, () => {
      this.getPriceDetail()
    })
  }

  updatePeopleCount(index, counter) {
    const guests = this.state.guests
    guests[index] = Object.assign({}, guests[index], counter)
    this.setState({ guests: guests }, () => {
      this.getPriceDetail()
    })
  }

  // 最大部屋人数を計算する
  // max_roomsによってプルダウンメニューを作成する
  updateMaxRooms() {
    const { rooms, calendars, checkin, checkout } = this.state

    if (
      this.state.calendar_loading ||
      checkin == null ||
      checkout == null ||
      checkin.isSameOrAfter(checkout)
    ) {
      return
    }

    const start = moment(checkin).clone().startOf("day")
    const checkoutPlusInterval = moment(checkout)
      .clone()
      .startOf("day")
      .add(this.props.interval_days - 1, "day")
    const filteredCalendars = []
      .concat(
        ...Object.values(calendars).map((dates) =>
          Object.values(dates).filter(
            ({ date }) =>
              moment(date).isSameOrAfter(start) &&
              moment(date).isSameOrBefore(checkoutPlusInterval)
          )
        )
      )
      .sort(({ date: a }, { date: b }) => (a == b ? 0 : a > b ? 1 : -1))

    // calendarとcheckinとcheckoutからmaxRoomを計算する
    const interval = moment(checkout).clone().startOf("day")
    let lastAvailableInventories
    const maxRooms =
      filteredCalendars.length &&
      Math.min(
        ...filteredCalendars.map((c) => {
          if (moment(c.date).isBefore(interval)) {
            lastAvailableInventories =
              (c.is_open && c.price && c.inventories) || 0
            return lastAvailableInventories
          }

          // priceがnullの場合、カレンダーレコードが未登録ということ
          // また、準備期間用のカレンダーレコードは未登録でも受付可能
          return c.price == null
            ? lastAvailableInventories || rooms
            : c.inventories || 0
        })
      )

    const key = maxRooms > 0 && rooms > maxRooms ? "rooms" : "max_rooms"
    this.setState({ [key]: maxRooms })
  }

  updateMinimumPrice(minimumPrice) {
    if (this.state.checkin) {
      const calendar =
        this.state.calendars[this.state.checkin.format("YYYY-MM")]
      if (calendar) {
        Object.keys(calendar).map((k) => {
          if (minimumPrice > calendar[k].price) {
            minimumPrice = calendar[k].price
          }
        })
      }
    }
    this.setState({ minimum_price: minimumPrice })
  }

  updateMinimumPriceFromDetail(dates) {
    const prices = Object.keys(dates).map((d) => {
      return dates[d].map((r) => r.price).reduce((sum, price) => sum + price)
    })
    this.setState({ minimum_price: Math.min.apply(null, prices) })
  }

  getRoomGuestInfo() {
    return this.state.guests.map((guest) => {
      const res = {}
      Object.keys(guest).map((k) => {
        res[`${k}_num`] = guest[k]
      })
      return res
    })
  }

  async getPriceDetail() {
    if (
      !moment.isMoment(this.state.checkin) ||
      !moment.isMoment(this.state.checkout)
    ) {
      this.setState({ showBookingBoxTrigger: true })
      return
    }

    const hasError = this.state.guests.some(
      (guest) => !!this.validateMaxGuests(guest)
    )
    if (hasError) return

    const dateFormat = "YYYY-MM-DD"
    const params = {
      checkin: this.state.checkin.format(dateFormat),
      checkout: this.state.checkout.format(dateFormat),
      rooms: this.getRoomGuestInfo(),
      user_prefecture: this.state.viewData.userPrefecture || "unknown",
      currency: CurrencyHelper.metaCurrencyCode()
    }
    if (this.props.is_preview) {
      // param only for preview
      params.room_group_id = this.props.room_group_id
    }

    const priceDetailEndpoint = this.props.is_preview
      ? routeUrlHelper.previewPricesPath(this.props.room_group_id)
      : routeUrlHelper.listingPricesPath(this.props.room_group_id)

    this.setState({ calculating: true })
    const postApi = new PostApi()
    await postApi
      .execute(priceDetailEndpoint, params)
      .then((res) => {
        this.setState({ prices: res.body })
        this.updateMinimumPriceFromDetail(res.body.dates)
      })
      .catch((res) => {
        this.setState({
          prices: {
            total_price: 0,
            service_fee: 0,
            consumption_tax: 0,
            cleaning_fee: 0,
            accommodation_fee: 0,
            additional_person_fee: 0,
            hotel_tax: 0,
            normal_accommodation_fee: 0,
            dates: []
          }
        })
        this.updateMinimumPrice(this.props.minimum_price)
      })
      .then((res) => {
        this.setState({ calculating: false, showBookingBoxTrigger: true })
      })
  }

  toggleBookingDetail(e) {
    e.preventDefault()
    this.setState({ showBookingDetail: !this.state.showBookingDetail }, () => {
      if (this.state.showBookingDetail === true) {
        document.body.classList.add("scroll-lock-sp-only")
      } else {
        document.body.classList.remove("scroll-lock-sp-only")
        ReactDOM.findDOMNode(this).scrollTop = 0
      }
    })
  }

  getTransitionUrl() {
    if (!this.isDisableNextStep()) {
      const params = {
        id: this.props.room_group_id,
        checkin: this.state.checkin.format("YYYY-MM-DD"),
        checkout: this.state.checkout.format("YYYY-MM-DD"),
        currency: CurrencyHelper.metaCurrencyCode()
      }
      const query = queryString.stringify(params)
      const rooms = this.parseGuestCountToQuery()
      return `${routeUrlHelper.paymentsBooksPath()}?${query}&${rooms}`
    }
  }

  async onBookingBtnClick(e) {
    e.preventDefault()
    if (this.state.checkin == null) {
      this.setState({ focused_checkin: true })
    } else if (this.state.checkout == null) {
      this.setState({ focused_checkout: true })
    } else if (!this.isDisableNextStep()) {
      await this.props.loginActions.isLogin()
      if (!this.props.login.isLogin) {
        this.props.modalActions.setState({ scrollTop: window.scrollY })
        document.body.classList.add("no-scrolling")
        document.body.style.top = `-${this.props.modal.scrollTop}px`
        this.props.modalActions.showLoginModal()
        this.props.loginActions.setState({
          returnUrl: this.getTransitionUrl()
        })
      } else {
        location.assign(this.getTransitionUrl())
      }
    }
  }

  parseGuestCountToQuery() {
    const result = this.state.guests.map((guest, i) => {
      const anRoom = Object.keys(guest).map((key) => {
        return `rooms_${i}_${key}=${guest[key]}`
      })
      return anRoom.join("&")
    })
    return result.join("&")
  }

  isDisableNextStep() {
    if (this.props.is_preview) {
      return true
    } else if (
      !moment.isMoment(this.state.checkin) ||
      !moment.isMoment(this.state.checkout)
    ) {
      return true
    } else if (this.state.checkin.isSameOrAfter(this.state.checkout)) {
      return true
    } else if (!this.isStayNightsAllowed(this.state.checkin, this.state.checkout)) {
      return true
    } else if (this.state.prices.total_price === 0) {
      return true
    } else if (this.state.calculating) {
      return true
    }
    return !this.isAvailableBetween(this.state.checkin, this.state.checkout)
  }

  initialVisibleMonth(key) {
    let date
    if (key == "checkin") {
      date =
        this.state.checkin ||
        (this.state.checkout
          ? moment(this.state.checkout).add(-1, "day")
          : moment())
    } else if (key == "checkout") {
      date = this.checkoutVisibleMonth()
    }
    date.locale(this.props.lang)
    return date
  }

  defaultCheckoutVisibleMonth(checkin = this.state.checkin, checkout = null) {
    const date =
      checkout ||
      (checkin ? moment(checkin).add(1, "day") : moment())

    return moment(date).startOf("month").locale(this.props.lang)
  }

  checkoutVisibleMonth() {
    if (this.state.checkout_visible_month) {
      return moment(this.state.checkout_visible_month).locale(this.props.lang)
    }

    return this.defaultCheckoutVisibleMonth(
      this.state.checkin,
      this.state.checkout
    )
  }

  checkoutPickerKey() {
    const checkinKey = this.state.checkin
      ? this.state.checkin.format("YYYY-MM-DD")
      : "unselected"

    return `checkout-${checkinKey}-${this.checkoutVisibleMonth().format("YYYY-MM")}`
  }

  checkinPickerKey() {
    const checkoutKey = this.state.checkout
      ? this.state.checkout.format("YYYY-MM-DD")
      : "unselected"

    return `checkin-${checkoutKey}`
  }

  validateMaxGuests(guest) {
    const infantKey = "infant"
    const limitInfant = 5

    let num = 0
    for (let key in guest) {
      if (key !== infantKey) {
        num += guest[key] | 0
      }
    }
    const isMaximumGuests = this.props.maximum_guests < num
    const isLimitInfant = guest[infantKey] > limitInfant

    if (isMaximumGuests || isLimitInfant) {
      // 最大宿泊者人数を超えた場合
      const errorMsg = isMaximumGuests
        ? "最大宿泊者"
        : isLimitInfant
          ? "最大乳幼児"
          : ""
      return (
        <div className="error" style={{ marginLeft: 0 }}>
          {errorMsg}人数を超えています
        </div>
      )
    }
    return null
  }

  /**
   * プレビュー画面の場合は予約をするわけではないので基本価格（base_price）、
   * それ以外（リスティング詳細）では最低金額を返す。
   */
  getDisplayPrice() {
    return this.props.is_preview
      ? this.state.base_price
      : this.state.minimum_price
  }

  getSimpleLocaledDate(date) {
    if (!date) {
      return null
    }
    const formatString = this.props.lang === "ja" || this.props.lang === "zh-TW" ? "M月D日" : "MMM. D"
    return date.locale(this.props.lang).format(formatString)
  }

  getTotalPax() {
    let pax = 0
    this.state.guests.forEach( room => {
      pax += room.adult + room.child + room.infant
    })
    return pax
  }

  shouldDisplayTotalPrice() {
    return this.state.checkin && this.state.checkout && this.state.prices.total_price > 0
  }

  render() {
    const { t } = this.props
    const currencySymbol = CurrencyHelper.getSymbolFromSelectedCurrency()

    return (
      <React.Fragment>
        <div
          styleName={`booking-box${
            this.state.showBookingDetail ? " active" : ""
          }`}
        >
          <div
            styleName={`booking-outline${
              this.shouldDisplayTotalPrice() ? " active" : ""
            }`}
          >
            {this.shouldDisplayTotalPrice()
              ? <div styleName="booking-min-price">
                <span className="notranslate">
                  <span styleName="price-prefix">{currencySymbol}</span>
                  {commaNumber(this.getDisplayPrice())}
                </span>
                <span styleName="price-suffix">{t("calendar.night")}</span>
              </div>
              : ''
            }
            <div styleName="close-area">
              <button
                styleName="close-button"
                onClick={this.toggleBookingDetail.bind(this)}
              >
                <img src="/assets/image/common/icon_close.svg" />
              </button>
            </div>
          </div>
          <div styleName="booking-requirements">
            <div styleName="booking-date-range">
              <div>
                <div styleName="caption">{t("calendar.checkin")}</div>
                <div className="calendar-select-day-input-wrap notranslate" styleName="datepicker-wrapper">
                  {/*
                    TODO: Consider to implement DateRangePicker instead of SingleDatePicker.
                    Or, should be create wrapper component for SingleDatePicker if use it.
                  */}
                  <SingleDatePicker
                    // react-dates keeps day modifiers internally, so remount when
                    // the selected checkout changes.
                    key={this.checkinPickerKey()}
                    hideKeyboardShortcutsPanel
                    id="date-from"
                    placeholder="YYYY/MM/DD"
                    date={this.state.checkin}
                    focused={this.state.focused_checkin}
                    initialVisibleMonth={() =>
                      this.initialVisibleMonth("checkin")
                    }
                    onDateChange={this.onDateChange.bind(this, "checkin")}
                    onFocusChange={this.onDatePickerFocusChange.bind(
                      this,
                      "checkin"
                    )}
                    numberOfMonths={1}
                    isDayBlocked={this.isDayBlocked.bind(this, "checkin")}
                    onPrevMonthClick={this.changePickerMonth.bind(this, true)}
                    onNextMonthClick={this.changePickerMonth.bind(this, false)}
                    monthFormat={
                      this.props.lang == "ja" ? "YYYY年MMMM" : "MMMM YYYY"
                    }
                    isOutsideRange={(day) =>
                      moment(day)
                        .tz(this.props.timezone)
                        .isBefore(moment(this.today.format("YYYY-MM-DD")))
                    }
                  />
                </div>
              </div>
              <div>
                <div styleName="caption">{t("calendar.checkout")}</div>
                <div className="calendar-select-day-input-wrap notranslate" styleName="datepicker-wrapper">
                  <SingleDatePicker
                    // react-dates keeps day modifiers internally, so remount when
                    // the selected check-in or visible month changes.
                    key={this.checkoutPickerKey()}
                    hideKeyboardShortcutsPanel
                    anchorDirection={ANCHOR_RIGHT}
                    id="date-to"
                    placeholder="YYYY/MM/DD"
                    date={this.state.checkout}
                    focused={this.state.focused_checkout}
                    initialVisibleMonth={() =>
                      this.initialVisibleMonth("checkout")
                    }
                    onDateChange={this.onDateChange.bind(this, "checkout")}
                    onFocusChange={this.onDatePickerFocusChange.bind(
                      this,
                      "checkout"
                    )}
                    numberOfMonths={1}
                    isDayBlocked={this.isDayBlocked.bind(this, "checkout")}
                    onPrevMonthClick={this.changeCheckoutPickerMonth.bind(
                      this,
                      true
                    )}
                    onNextMonthClick={this.changeCheckoutPickerMonth.bind(
                      this,
                      false
                    )}
                    monthFormat={
                      this.props.lang == "ja" ? "YYYY年MMMM" : "MMMM YYYY"
                    }
                  />
                </div>
              </div>
            </div>
            <div className="calendar-select-price">
              <div styleName="caption">{t("calendar.number_of_room")}</div>
              <div
                className="calendar-select-price-input-wrap search-reservation-nselect-wrap"
                styleName="search-reservation-nselect-wrap"
              >
                <select
                  className="w-select"
                  onChange={this.updateRoomCount.bind(this)}
                  value={this.state.guests.length}
                >
                  {this.state.max_rooms === 0 ? (
                    <option value="1">1 {t("calendar.rooms")}</option>
                  ) : (
                    [...Array(this.state.max_rooms)].map((_, i) => {
                      const v = i + 1
                      return (
                        <option value={v} key={UniqId()}>
                          {v}
                          {t("calendar.rooms", { count: v })}
                        </option>
                      )
                    })
                  )}
                </select>
              </div>
            </div>
            {this.state.guests.map((values, i) => {
              /* NOTICE: Do not use UniqId() to root level element of this block.
              Because it will be destroy event handling of each children. */
              return (
                <div
                  className="calendar-select-price"
                  key={`people_counter${i}`}
                >
                  <div styleName="caption">
                    {this.state.guests.length > 1 ? (
                      <span>
                        <span>{t("calendar.number_of_guest")} : </span>
                        <Trans i18nKey="calendar.room_order">
                          <span className="notranslate">{{count: i + 1}}</span>
                          <span>部屋目</span>
                        </Trans>
                      </span>
                    ) : (
                      <span>{t("calendar.number_of_guest")}</span>
                    )}
                  </div>
                  <div
                    className="calendar-select-price-input-wrap"
                  >
                    <PeopleCounter
                      maximum_guests={this.props.maximum_guests}
                      adult={values.adult}
                      child={values.child}
                      infant={values.infant}
                      isDisabled={this.state.guests.length == 0}
                      updateCounter={this.updatePeopleCount.bind(this, i)}
                      allowInfants={this.props.allowInfants}
                    />
                  </div>
                  {this.validateMaxGuests(values)}
                </div>
              )
            })}
          </div>
          {this.shouldDisplayTotalPrice() &&
            <PriceDetail
              prices={this.state.prices}
              discount_rate={this.props.discount_rate}
              calculating={this.state.calculating}
              showAdditionalDiscounts={true}
              countryCode={this.props.countryCode}
            />
          }
          <div styleName="booking-button-area">
            <button
              styleName={`booking-ok-btn${
                this.shouldDisplayTotalPrice() ? "" : " filling"
              }`}
              onClick={this.onBookingBtnClick.bind(this)}
            >
              {this.shouldDisplayTotalPrice()
                ? t("calendar.book")
                : t("calendar.alert_set_date")
              }
            </button>
          </div>
        </div>
        {this.state.showBookingBoxTrigger
          ? <button
            styleName={`booking-box-fixed${
              this.shouldDisplayTotalPrice() ? "" : " filling"
            }`}
            onClick={this.toggleBookingDetail.bind(this)}
          >
            <div styleName="booking-box-trigger">
              {this.shouldDisplayTotalPrice()
                ? <React.Fragment>
                  <div styleName="booking-min-price">
                    <div styleName="conditions">
                      <span>
                        {`${this.getSimpleLocaledDate(this.state.checkin)} - ${this.getSimpleLocaledDate(this.state.checkout)},`}
                      </span>
                      <span>
                        {`${this.getTotalPax()} ${t("calendar.pax")}`}
                      </span>
                    </div>
                    <span className="notranslate">
                      <span styleName="price-prefix">{currencySymbol}</span>
                      {commaNumber(this.state.prices.total_price)}
                    </span>
                  </div>
                  <div styleName="booking-box-fixed-label">
                    {this.state.prices.total_price > 0
                      ? t("calendar.price_detail")
                      : t("calendar.see_availability")
                    }
                  </div>
                </React.Fragment>
                : <React.Fragment>
                  <div styleName="booking-confirmation">
                    <span>{t("calendar.confirmation")}</span>
                  </div>
                </React.Fragment>
              }
            </div>
          </button>
          : ''
        }
        <Modal />
      </React.Fragment>
    )
  }
}

Calendar.propTypes = {
  room_group_id: PropTypes.number.isRequired,
  minimum_price: PropTypes.number.isRequired,
  maximum_guests: PropTypes.number.isRequired,
  accept_days: PropTypes.number.isRequired,
  accept_days_hour: PropTypes.number.isRequired,
  is_instant_booking: PropTypes.bool.isRequired,
  minimum_stays: PropTypes.number.isRequired,
  maximum_stays: PropTypes.number.isRequired,
  isLogin: PropTypes.bool,
  is_preview: PropTypes.bool,
  discount_rate: PropTypes.number,
  interval_days: PropTypes.number.isRequired,
  lang: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired
}

Calendar.defaultProps = {
  room_group_id: 0,
  minimum_price: 0,
  maximum_guests: 1,
  accept_days: 0,
  accept_days_hour: 0,
  is_instant_booking: false,
  minimum_stays: 1,
  maximum_stays: 1,
  is_preview: false,
  discount_rate: 0,
  interval_days: 0,
  lang: "ja",
  isLogin: false,
  countryCode: "jp"
}

export default compose(withNamespaces("listings"))(Calendar)
